import { createContext } from 'react'; // eslint-disable-next-line @typescript-eslint/no-empty-function

var noop = function noop() {};

var GroupContext = /*#__PURE__*/createContext({
  value: [],
  addToValue: noop,
  removeFromValue: noop,
  inGroup: false
});
export { GroupContext };
